import { reaction, computed } from 'mobx';
import PAYMENT_PROVIDERS from '../../../constants/PaymentProviders';
import { FIELD_TYPE } from '../../../constants/Constants';
import { ADDRESS_NOTIFICATIONS, NOTIFICATION_GROUP, NOTIFICATION_TYPE } from '../../../constants/Notifications';
import BillingRepository from '../../../repositories/BillingRepository';
import BaseNotificationManager, { IBaseNotificationManagerConfig } from './BaseNotificationManager';

interface IAfterpayNotifServiceConfig extends IBaseNotificationManagerConfig {
  billingRepository: BillingRepository;
}

export default class AfterpayNotificationManager extends BaseNotificationManager {

  protected billingRepository: BillingRepository;

  constructor(config: IAfterpayNotifServiceConfig) {
    super(config);
    this.billingRepository = config.billingRepository;
  }

  init(): void {
    this.setupReactions();
  }

  private setupReactions(): void {
    reaction(() => this.isAftperpayBillingAddressWarningEligible, enableNotification => this.setAfterpayBillingNotification(enableNotification));
  }

  @computed
  get isBillingFormSameCountryAsConfig(): boolean {
    const formCountryId = this.billingRepository.formStore.values[FIELD_TYPE.COUNTRY_ID];
    return !formCountryId || (formCountryId === this.config.countryId);
  }

  @computed
  get isAfterpayPaymentAvailable(): boolean {
    const { transaction } = this.transactionRepository;
    return transaction?.payment.isPaymentPresent(PAYMENT_PROVIDERS.AFTERPAY);
  }
      
  @computed 
  get isAftperpayBillingAddressWarningEligible(): boolean {
    const { transaction } = this.transactionRepository;

    if (!this.isAfterpayPaymentAvailable) {
      return false;
    }

    const selectedAddressWarning =
            !transaction.billingAddress.isNewAddress &&
            transaction.billingAddress.attributes[FIELD_TYPE.COUNTRY_ID] !== this.config.countryId;

    const newAddressWarning = !this.isBillingFormSameCountryAsConfig && transaction.billingAddress.isNewAddress;

    return selectedAddressWarning || newAddressWarning;
  }

  private setAfterpayBillingNotification(enableNotification: boolean): void {
    if (enableNotification) {
      this.notificationsCollection.addNotification({
        group: NOTIFICATION_GROUP.BILLING_PAYMENT_WARNING,
        key: ADDRESS_NOTIFICATIONS.AFTERPAY_UNAVAILABLE,
        type: NOTIFICATION_TYPE.WARNING,
      });
    } else {
      this.notificationsCollection.clearNotificationByKey(ADDRESS_NOTIFICATIONS.AFTERPAY_UNAVAILABLE);
    }
  }
}